import checkout from "./form3";

const {
  formField3: {
    taxpayers,
    taxCode,

    supportData,
  },
} = checkout;

const initialValues3 = {
  [taxpayers.name]: "",
  [taxCode.name]: "",

  [supportData.name]: false,
};

export default initialValues3;
